module.exports = __webpack_public_path__ + "media/images/lp/marutuke-59a174ed0ba122dec8c8ead3cd1d26e7.gif";